import React, { useState } from 'react';
import { find, get, orderBy, uniqueId, uniqBy } from 'lodash';
import axios from 'axios';
import { SdfButton } from '@synerg/react-components';
import { AdminRoleTypes, AdminsTable, AddAdmin } from 'shared-one-ux-components';
import { memberContainsAdminRoles } from 'shared-one-ux-components';
import { widthHeight, marginTop } from './utility/utility';
import Toast from '../common/toast';

export default function Roles() {
	const [toast, setToast] = useState({ isActive: false, key: '', status: '', message: '', showToast: true });

	const [allRoles, setAllRoles] = useState([]);
	const [memberRoles, setMemberRoles] = useState([]);
	const [loggedInAoid, setLoggedInAoid] = useState(false);

	const [membersList, setMembersList] = useState([]);
	const [busyIndicator, setBusyIndicator] = useState(false);

	const [addAdmin, setAddAdmin] = useState(false);
	const [addNewMembers, setAddNewMembers] = useState([]);

	const [searchReset, setSearchReset] = useState('');

	async function getExistingMembers() {
		try {
			setSearchReset('');
			setBusyIndicator(true);

			const { data: { data:  { membersList, allRoles, loggedInAoid } }, status } = await axios.get(
				`${import.meta.env.VITE_ROOT_PATH}/api/admin-clients/all`
			);

			setLoggedInAoid(loggedInAoid || null);
			if (status === 200 && membersList && membersList.length > 0) {
				const members = membersList.map((member) => {
					let memberTemp = {
						'firstName': get(member, 'name.givenName', ''),
						'lastName': get(member, 'name.familyName', ''),
						'userId': get(member, 'userName', ''),
						'email': get(find(get(member, 'contactInfo', []), {communicationType: 'EMAIL'} ), 'contactInfo', ''),
						'phone': get(find(get(member, 'contactInfo', []), {communicationType: 'CELL_PHONE'} ), 'contactInfo', ''),
						'aoid': get(member, 'associateOID', ''),
						'roles': orderBy(get(member, 'roles', []), ['name'],['desc']),
						'isLoggedInUser': get(member, 'associateOID', '') === loggedInAoid
					}
					if (memberTemp.isLoggedInUser) {
						//Remove duplicates
						let uniqueRoles = uniqBy((memberTemp.roles || []), function (e) {
							return e.id;
						});
						setMemberRoles(uniqueRoles);
					}
					return memberTemp;
				}) || [];
				const admin_roles = allRoles.map(role => { return {roleId: role.id, roleName: role.name, roleCode: role.role }})
				if (admin_roles.length > 0) {
					let temp = [];
					for (let member of members) {
						const mappedRoles = member.roles.map(role => { return {roleId: role.id, roleName: role.name, roleCode: role.role }})
						let result = await memberContainsAdminRoles(
							mappedRoles || [], admin_roles);
						if (result['foundAtLeastOne'] === true) {
							member.roles = result['acceptedRoles'].reduce((unique, o) => {
								if(!unique.some(obj => obj.roleId === o.roleId && obj.roleCode === o.roleCode)) {
									unique.push(o);
								}
								return unique;
							}, []);
							temp.push(member);
						}
					}
					setAllRoles(admin_roles);
					setMembersList(temp);
				} else {
					setMembersList([]);
				}

			} else {
				setMembersList([]);
			}
		} catch (e) {
			setMembersList([]);
			setToast({
				isActive: true,
				status: 'error',
				message: `Error occurred while fetching admins. Please try again later.`,
				showToast: true
			});
		} finally {
			setBusyIndicator(false);
		}
	}

	async function fetchSearchedTerm(searchTerm) {
		try {
			const url = `${import.meta.env.VITE_ROOT_PATH}/api/admin-contacts/name/${searchTerm}`;
			const {data, status} = await axios.get(url);
			if (status === 200) {
				if (data.length === 0) {
					setAddNewMembers([]);
				} else {
					// eslint-disable-next-line array-callback-return
					const filtered = data.filter((row) => {
						if (row && row.hasOwnProperty('associateOID')
							&& row.hasOwnProperty('self') && !row.self)
							return row
					});

					// eslint-disable-next-line array-callback-return
					const rowData = filtered.map(function(row) {
						if (row) {
							const checkFirstName = get(row, 'legalName.givenName', '');
							const checkLastName = get(row, 'legalName.familyName1', '');
							const checkEmail = get(row, 'businessCommunication.emails[0].emailUri','');
							const checkPhone = get(row, 'businessCommunication.mobiles', '' );

							return {
								userName: checkFirstName + ' ' + checkLastName,
								userId: row.userId || "NA",
								email: checkEmail,
								addButton: "button",
								associateOID: row.associateOID || '',
								firstName: checkFirstName,
								lastName: checkLastName,
								phone: checkPhone,
								rolesSelected: []
							}
						}
					})
					setAddNewMembers(rowData);
				}
			} else {
				setAddNewMembers([]);
				setToast({
					isActive: true,
					status: 'error',
					message: `Error occurred while searching for user!`,
					showToast: true
				});
			}
			setBusyIndicator(false);
		} catch (e) {
			setAddNewMembers([]);
			setToast({
				isActive: true,
				status: 'error',
				message: `Error occurred while searching for user!`,
				showToast: true
			});
			setBusyIndicator(false);
		}
	}

	const submitNewAdmin = async (reqBody) => {
		try {
			setBusyIndicator(true);
			const response = await axios.post(
				`${import.meta.env.VITE_ROOT_PATH}/api/admin/role/assign`, {
					selectedValues: reqBody.roles,
					associateOID: reqBody.aoid
				}
			);
			const success = get(response, 'data.success', false);
			if (success) {
				setToast({
					isActive: true,
					key: uniqueId(),
					status: 'success',
					message: `Successfully added roles to ${reqBody.firstName} ${reqBody.lastName}.`,
					showToast: true
				});
			}  else {
				setBusyIndicator(false);
				const errorMessage = get(response, 'response.data.message', 'Something went wrong while adding this user. Please try again.');
				setToast({
					isActive: true,
					key: uniqueId(),
					status: "error",
					message: `${errorMessage}`,
					showToast: true
				});
			}
		} catch (e) {
			const errorMessage = get(e, 'response.data.message', 'Something went wrong while adding this user. Please try again.');
			setToast({
				isActive: true,
				key: uniqueId(),
				status: "error",
				message: `${errorMessage}`,
				showToast: true
			});
		} finally {
			setBusyIndicator(false);
		}
	};

	const postMemberRoles = async (reqBody) => {
		try {
			setBusyIndicator(true);
			const response = await axios.post(`${import.meta.env.VITE_ROOT_PATH}/api/admin/role/update`, reqBody);
			const success = get(response, 'data.success', false);
			if (success) {
				getExistingMembers();
				setToast({
					isActive: true,
					key: uniqueId(),
					status: 'success',
					message: `Success! You've updated the role for ${reqBody.firstName + " " + reqBody.lastName}`,
					showToast: true
				});
				// cancelModal();
			}  else {
				setBusyIndicator(false);
				const errorMessage = get(response, 'response.data.message', 'Something went wrong while updating roles for this user. Please try again.');
				let type = "error";
				if (errorMessage.includes('Logged in')) {
					type = "warning";
				}
				setToast({
					isActive: true,
					key: uniqueId(),
					status: type,
					message: `${errorMessage}`,
					showToast: true
				});
			}
		} catch (e) {
			setBusyIndicator(false);
			const errorMessage = get(e, 'response.data.message', 'Something went wrong while updating roles for this user. Please try again.');
			setToast({
				isActive: true,
				key: uniqueId(),
				status: 'error',
				message: `${errorMessage}`,
				showToast: true
			});
		}
	};

	const deleteAdmin = async (reqBody) => {
		try {
			const { status } = await axios.post(`${import.meta.env.VITE_ROOT_PATH}/api/role/unassign`,
				{ associateOID: reqBody.aoid }
			);
			return status;
		}  catch (e) {
			return e.request.status;
		}
	};

	return (
		<div className="mx-24 items-center my-10">
			<span className={'mt-8 w-20 text-md leading-none pl-1 '}>Roles /</span>
			<h1 className="text-4xl font-bold">Role Management</h1>
			<div className="flex my-4 mx-0 items-center justify-between mt-12">
				<div className="order-1 lg:w-9/12">
					<div className="order-1">
						<div className="text-3xl font-bold" style={widthHeight('534px', '40px')}>
							Admin roles
						</div>
					</div>
					<div className="order-2" style={widthHeight('990px', '48px')}>
						<p>There are times when you may need others within your
							organization to have access to this application.
							In order to make this application available to them, select the
							add user button then search for co-workers by name
							to assign them the appropriate admin role.</p>
					</div>
				</div>
				<div className="order-2">
					<SdfButton emphasis="primary" onClick={() => {
						setAddAdmin(true);
					}}>
						Add user(s)
					</SdfButton>
				</div>
			</div>
			<div className="flex my-4 mx-0" style={marginTop('59px')}>

				<div className="order-1 xl:max-w-4/5 pr-10">
					<div className="text-2xl font-bold">Role types</div>
					<div style={marginTop('38px')}>
						<AdminRoleTypes/>
					</div>
				</div>
				{/*ADMIN SEARCH AND SDF GRID TABLE BELOW*/}
				<div className="order-2" style={widthHeight('100%', '100%')}>
					{membersList ? <AdminsTable
						setToastData={setToast}
						adminRoles={allRoles}
						fetchExistingMembers={getExistingMembers}
						memberRoles={memberRoles}
						busyIndicator={busyIndicator}
						loggedInAoid={loggedInAoid}
						membersList={membersList}
						searchReset={searchReset}
						setSearchReset={setSearchReset}
						postMemberRoles={postMemberRoles}
						deleteAdmin={deleteAdmin}
					/> : null}
				</div>

			</div>
			{addAdmin &&
				<AddAdmin open={addAdmin}
					setAdmin={setAddAdmin}
					roles={memberRoles}
					adminRoles={allRoles}
					fetchExistingMembers={getExistingMembers}
					addNewMembers={addNewMembers}
					fetchSearchedTerm={fetchSearchedTerm}
					submitNewAdmin={submitNewAdmin}
					busyIndicator={busyIndicator}
					setBusyIndicator={setBusyIndicator}
				/>
			}
			{toast && toast.isActive && <Toast
				key={toast.key}
				status={toast.status}
				message={toast.message}
				showToast={toast.showToast}
			/>}
		</div>);
};
